import { ValidationResults } from './ValidationResult';

export type CommandResult<T = unknown> = FailureCommandResult | SuccessCommandResult<T>;

export interface SuccessCommandResult<T> {
  ErrorCode?: number;
  IsFailure: false;
  IsSuccess: true;
  Result: T;
  ValidationResult: ValidationResults;
}

export interface FailureCommandResult {
  ErrorCode?: number;
  IsFailure: true;
  IsSuccess: false;
  Result: unknown;
  ValidationResult: ValidationResults;
}

export function isCommandResult<T = unknown>(dto: any): dto is CommandResult<T> {
  return dto && 'IsSuccess' in dto && 'ValidationResult' in dto;
}
